// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import AppSystemListResultModel from '../../model/app-system-list-result-model';
import AppSystemListResultDTO from '../dto/app-system-list-result-dto';
import dtoSchema from '../schemas/app-system-list-result-schema';
import AppSystemModel from '../../model/app-system-model';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class AppSystemListResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<AppSystemListResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => AppSystemModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
    }
  }
  /**
  */
  items?: AppSystemModel[];
  /**
  */
  links?: ResourceLinkModel[];

  static toModel(dto: DeepPartial<AppSystemListResultDTO>): AppSystemListResultModel;
  static toModel(dto: DeepPartial<AppSystemListResultDTO> | undefined | null): AppSystemListResultModel | undefined;
  static toModel(dto: DeepPartial<AppSystemListResultDTO> | undefined | null): AppSystemListResultModel | undefined {
    return dto ? new AppSystemListResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<AppSystemListResultModel> | AppSystemListResultModel): AppSystemListResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
    } as AppSystemListResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for AppSystemListResultModel, can not map to AppSystemListResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
